import { ReduceStore }  from 'flux/utils';
import AppDispatcher    from '~/dispatchers/app_dispatcher';
import VideoActionTypes from '~/types/video_action_types';

class VideoStore extends ReduceStore {
  constructor() {
    super(AppDispatcher);
  }

  getInitialState() {
    return {
      lastVideoStoreAction: null,
      errors:               {},
      submitting:           false,
      loadingVideos:        false,
      loadingLibraryVideos: false,
      videos:               [],
      loadingVideo:         false,
      video:                null,
      pagination:           {},
      videosLimit:          0,
      countOfVideos:        0,
      scopedRecords:        { videos: [] },
      scopedLoadings:       { videos: false },
      scopedQueries:        { videos: {} },
      ownerScope:           'all',
      videoScopeSize:       parseInt(localStorage.videoScopeSize, 10) || 10,
      libraryVideos:        [],
      libraryPagination:    {},
    };
  }

  loadVideos(state, action) {
    const newState = { ...state };
    const { table } = action;
    const tableScope = table?.scope || 'videos';
    newState.scopedLoadings[tableScope] = true;
    newState.lastVideoStoreAction = 'loadVideos';
    return newState;
  }

  loadVideosDone(state, action) {
    const newState = { ...state };
    const { table, response, query } = action;
    const tableScope = table?.scope || 'videos';
    newState.scopedLoadings[tableScope] = false;
    newState.scopedRecords[tableScope] = response;
    newState.scopedQueries[tableScope] = query;
    newState.pagination = response?.pagination || {};
    newState.lastVideoStoreAction = 'loadVideosDone';
    return newState;
  }

  loadVideosFail(state, action) {
    const newState = { ...state };
    const { table } = action;
    const tableScope = table?.scope || 'videos';
    newState.scopedLoadings[tableScope] = false;
    newState.errors[tableScope] = action.error?.response?.body?.errors || {};
    newState.lastVideoStoreAction = 'loadVideosFail';
    return newState;
  }

  loadTrashedVideos(state, action) {
    const newState = { ...state };
    const { table } = action;
    const tableScope = table?.scope || 'trash_videos';
    newState.scopedLoadings[tableScope] = true;
    newState.lastVideoStoreAction = 'loadTrashedVideos';
    return newState;
  }

  loadTrashedVideosDone(state, action) {
    const newState = { ...state };
    const { table, response, query } = action;
    const tableScope = table?.scope || 'trash_videos';
    newState.scopedLoadings[tableScope] = false;
    newState.scopedRecords[tableScope] = response;
    newState.scopedQueries[tableScope] = query;
    newState.lastVideoStoreAction = 'loadTrashedVideosDone';
    return newState;
  }

  loadTrashedVideosFail(state, action) {
    const newState = { ...state };
    const { table } = action;
    const tableScope = table?.scope || 'trash_videos';
    newState.scopedLoadings[tableScope] = false;
    newState.errors[tableScope] = action.error?.response?.body?.errors || {};
    newState.lastVideoStoreAction = 'loadTrashedVideosFail';
    return newState;
  }

  switchVideoScopeSize(state, action) {
    const newState = { ...state };

    newState.videoScopeSize = action.videoScopeSize;
    newState.lastVideoStoreAction = 'switchVideoScopeSize';

    return newState;
  }

  loadVideo(state, action) {
    const newState = { ...state };

    newState.loadingVideo = true;
    newState.lastVideoStoreAction = 'loadVideo';

    return newState;
  }

  loadVideoDone(state, action) {
    const newState = { ...state };

    newState.loadingVideo = false;
    newState.video = action.video;
    newState.lastVideoStoreAction = 'loadVideoDone';

    return newState;
  }

  loadVideoFail(state, action) {
    const newState = { ...state };

    newState.loadingVideo = false;
    newState.errors = action.errors;
    newState.lastVideoStoreAction = 'loadVideoFail';

    return newState;
  }

  createVideo(state, action) {
    const newState = { ...state };

    newState.submitting = true;
    newState.lastVideoStoreAction = 'createVideo';

    return newState;
  }

  createVideoDone(state, action) {
    const newState = { ...state };

    newState.errors = {};
    newState.submitting = false;
    newState.video = action.video;
    newState.lastVideoStoreAction = 'createVideoDone';

    return newState;
  }

  createVideoFail(state, action) {
    const newState = { ...state };

    newState.submitting = false;
    newState.errors = action.error.response.body.errors;
    newState.lastVideoStoreAction = 'createVideoFail';

    return newState;
  }

  updateVideo(state, action) {
    const newState = { ...state };

    newState.submitting = true;
    newState.lastVideoStoreAction = 'updateVideo';

    return newState;
  }

  updateVideoDone(state, action) {
    const newState = { ...state };

    newState.errors = {};
    newState.submitting = false;
    newState.video = action.video;
    newState.lastVideoStoreAction = 'updateVideoDone';

    return newState;
  }

  updateVideoFail(state, action) {
    const newState = { ...state };

    newState.submitting = false;
    newState.errors = action.error.response.body.errors;
    newState.lastVideoStoreAction = 'updateVideoFail';

    return newState;
  }

  deleteVideo(state, action) {
    const newState = { ...state };

    newState.lastVideoStoreAction = 'deleteVideo';

    return newState;
  }

  deleteVideoDone(state, action) {
    const newState = { ...state };

    newState.errors = {};
    newState.lastVideoStoreAction = 'deleteVideoDone';

    return newState;
  }

  deleteVideoFail(state, action) {
    const newState = { ...state };

    newState.lastVideoStoreAction = 'deleteVideoFail';

    return newState;
  }

  restoreVideo(state, action) {
    const newState = { ...state };

    newState.lastVideoStoreAction = 'restoreVideo';

    return newState;
  }

  restoreVideoDone(state, action) {
    const newState = { ...state };

    newState.lastVideoStoreAction = 'restoreVideoDone';

    return newState;
  }

  restoreVideoFail(state, action) {
    const newState = { ...state };

    newState.lastVideoStoreAction = 'restoreVideoFail';

    return newState;
  }

  permanentDeleteVideo(state, action) {
    const newState = { ...state };

    newState.lastVideoStoreAction = 'permanentDeleteVideo';

    return newState;
  }

  permanentDeleteVideoDone(state, action) {
    const newState = { ...state };

    newState.lastVideoStoreAction = 'permanentDeleteVideoDone';

    return newState;
  }

  permanentDeleteVideoFail(state, action) {
    const newState = { ...state };

    newState.lastVideoStoreAction = 'permanentDeleteVideoFail';

    return newState;
  }

  loadCategoriesDone(state, action) {
    return {
      ...state,
      categories:              action.categories,
      lastVideoStoreAction: 'loadCategoriesDone',
    };
  }

  loadLibraryVideos(state) {
    return {
      ...state,
      loadingLibraryVideos: true,
      lastVideoStoreAction: 'loadLibraryVideos',
    };
  }

  loadLibraryVideosDone(state, action) {
    const { response } = action;
    return {
      ...state,
      loadingLibraryVideos: false,
      libraryVideos: response.videos,
      libraryPagination: response.pagination,
      countOfVideos: response.count_of_videos,
      videosLimit: response.videos_limit,
      lastVideoStoreAction: 'loadLibraryVideosDone',
    };
  }

  loadLibraryVideosFail(state) {
    return {
      ...state,
      loadingLibraryVideos: false,
      lastVideoStoreAction: 'loadLibraryVideosFail',
    };
  }

  bulkUpdateVideos(state, action) {
    const newState = { ...state };
    const { tableScope } = action;

    newState.bulkUpdatedTables = newState.bulkUpdatedTables || {};
    newState.bulkUpdatedTables[tableScope] = false;
    newState.lastVideoStoreAction = 'bulkUpdateVideos';

    return newState;
  }

  bulkUpdateVideosDone(state, action) {
    const newState = { ...state };
    const { tableScope } = action;

    newState.bulkUpdatedTables = newState.bulkUpdatedTables || {};
    newState.bulkUpdatedTables[tableScope] = true;
    newState.lastVideoStoreAction = 'bulkUpdateVideosDone';

    return newState;
  }

  bulkUpdateVideosFail(state, action) {
    const newState = { ...state };
    const { tableScope } = action;

    newState.bulkUpdatedTables = newState.bulkUpdatedTables || {};
    newState.bulkUpdatedTables[tableScope] = false;
    newState.lastVideoStoreAction = 'bulkUpdateVideosFail';

    return newState;
  }

  bulkDeleteVideos(state, action) {
    const newState = { ...state };
    const { tableScope } = action;

    newState.bulkUpdatedTables = newState.bulkUpdatedTables || {};
    newState.bulkUpdatedTables[tableScope] = false;
    newState.lastVideoStoreAction = 'bulkDeleteVideos';

    return newState;
  }

  bulkDeleteVideosDone(state, action) {
    const newState = { ...state };
    const { tableScope } = action;

    newState.bulkUpdatedTables = newState.bulkUpdatedTables || {};
    newState.bulkUpdatedTables[tableScope] = false;
    newState.lastVideoStoreAction = 'bulkDeleteVideosDone';

    return newState;
  }

  bulkDeleteVideosFail(state, action) {
    const newState = { ...state };
    const { tableScope, error } = action;

    newState.scopedLoadings[tableScope] = false;
    newState.bulkDeleting = false;
    newState.error = error;

    newState.lastVideoStoreAction = 'bulkDeleteVideosFail';
    return newState;
  }

  bulkRestoreTrashVideos(state, action) {
    const newState = { ...state };
    const { tableScope } = action;

    newState.scopedLoadings[tableScope] = true;
    newState.lastVideoStoreAction = 'bulkRestoreTrashVideos';
    return newState;
  }

  bulkRestoreTrashVideosDone(state, action) {
    const newState = { ...state };
    const { tableScope } = action;

    newState.scopedLoadings[tableScope] = false;
    newState.lastVideoStoreAction = 'bulkRestoreTrashVideosDone';
    return newState;
  }

  bulkRestoreTrashVideosFail(state, action) {
    const newState = { ...state };
    const { tableScope, error } = action;

    newState.scopedLoadings[tableScope] = false;
    newState.error = error;
    newState.lastVideoStoreAction = 'bulkRestoreTrashVideosFail';
    return newState;
  }

  bulkDeleteTrashVideos(state, action) {
    const newState = { ...state };
    const { tableScope } = action;

    newState.scopedLoadings[tableScope] = true;
    newState.bulkDeleting = true;
    newState.lastVideoStoreAction = 'bulkDeleteTrashVideos';
    return newState;
  }

  bulkDeleteTrashVideosDone(state, action) {
    const newState = { ...state };
    const { tableScope } = action;

    newState.scopedLoadings[tableScope] = false;
    newState.bulkDeleting = false;
    newState.lastVideoStoreAction = 'bulkDeleteTrashVideosDone';
    return newState;
  }

  bulkDeleteTrashVideosFail(state, action) {
    const newState = { ...state };
    const { tableScope, error } = action;

    newState.scopedLoadings[tableScope] = false;
    newState.bulkDeleting = false;
    newState.error = error;
    newState.lastVideoStoreAction = 'bulkDeleteTrashVideosFail';
    return newState;
  }

  reduce(state, action) {
    switch (action.type) {
      case VideoActionTypes.LOAD_LIBRARY_VIDEOS:
        return this.loadLibraryVideos(state);

      case VideoActionTypes.LOAD_LIBRARY_VIDEOS_DONE:
        return this.loadLibraryVideosDone(state, action);

      case VideoActionTypes.LOAD_LIBRARY_VIDEOS_FAIL:
        return this.loadLibraryVideosFail(state);

      case VideoActionTypes.LOAD_VIDEOS:
        return this.loadVideos(state, action);

      case VideoActionTypes.LOAD_VIDEOS_DONE:
        return this.loadVideosDone(state, action);

      case VideoActionTypes.LOAD_VIDEOS_FAIL:
        return this.loadVideosFail(state, action);

      case VideoActionTypes.LOAD_TRASHED_VIDEOS:
        return this.loadTrashedVideos(state, action);

      case VideoActionTypes.LOAD_TRASHED_VIDEOS_DONE:
        return this.loadTrashedVideosDone(state, action);

      case VideoActionTypes.LOAD_TRASHED_VIDEOS_FAIL:
        return this.loadTrashedVideosFail(state, action);

      case VideoActionTypes.LOAD_VIDEO:
        return this.loadVideo(state, action);

      case VideoActionTypes.LOAD_VIDEO_DONE:
        return this.loadVideoDone(state, action);

      case VideoActionTypes.LOAD_VIDEO_FAIL:
        return this.loadVideoFail(state, action);

      case VideoActionTypes.CREATE_VIDEO:
        return this.createVideo(state, action);

      case VideoActionTypes.CREATE_VIDEO_DONE:
        return this.createVideoDone(state, action);

      case VideoActionTypes.CREATE_VIDEO_FAIL:
        return this.createVideoFail(state, action);

      case VideoActionTypes.SWITCH_VIDEO_SCOPE_SIZE:
        return this.switchVideoScopeSize(state, action);

      case VideoActionTypes.UPDATE_VIDEO:
        return this.updateVideo(state, action);

      case VideoActionTypes.UPDATE_VIDEO_DONE:
        return this.updateVideoDone(state, action);

      case VideoActionTypes.UPDATE_VIDEO_FAIL:
        return this.updateVideoFail(state, action);

      case VideoActionTypes.DELETE_VIDEO:
        return this.deleteVideo(state, action);

      case VideoActionTypes.DELETE_VIDEO_DONE:
        return this.deleteVideoDone(state, action);

      case VideoActionTypes.DELETE_VIDEO_FAIL:
        return this.deleteVideoFail(state, action);

      case VideoActionTypes.RESTORE_VIDEO:
        return this.restoreVideo(state, action);

      case VideoActionTypes.RESTORE_VIDEO_DONE:
        return this.restoreVideoDone(state, action);

      case VideoActionTypes.RESTORE_VIDEO_FAIL:
        return this.restoreVideoFail(state, action);

      case VideoActionTypes.LOAD_CATEGORIES_DONE:
        return this.loadCategoriesDone(state, action);

      case VideoActionTypes.BULK_UPDATE_VIDEOS:
        return this.bulkUpdateVideos(state, action);

      case VideoActionTypes.BULK_UPDATE_VIDEOS_DONE:
        return this.bulkUpdateVideosDone(state, action);

      case VideoActionTypes.BULK_UPDATE_VIDEOS_FAIL:
        return this.bulkUpdateVideosFail(state, action);

      case VideoActionTypes.BULK_DELETE_VIDEOS:
        return this.bulkDeleteVideos(state, action);

      case VideoActionTypes.BULK_DELETE_VIDEOS_DONE:
        return this.bulkDeleteVideosDone(state, action);

      case VideoActionTypes.BULK_DELETE_VIDEOS_FAIL:
        return this.bulkDeleteVideosFail(state, action);

      case VideoActionTypes.BULK_RESTORE_TRASH_VIDEOS:
        return this.bulkRestoreTrashVideos(state, action);

      case VideoActionTypes.BULK_RESTORE_TRASH_VIDEOS_DONE:
        return this.bulkRestoreTrashVideosDone(state, action);

      case VideoActionTypes.BULK_RESTORE_TRASH_VIDEOS_FAIL:
        return this.bulkRestoreTrashVideosFail(state, action);

      case VideoActionTypes.BULK_DELETE_TRASH_VIDEOS:
        return this.bulkDeleteTrashVideos(state, action);

      case VideoActionTypes.BULK_DELETE_TRASH_VIDEOS_DONE:
        return this.bulkDeleteTrashVideosDone(state, action);

      case VideoActionTypes.BULK_DELETE_TRASH_VIDEOS_FAIL:
        return this.bulkDeleteTrashVideosFail(state, action);

      default:
        return state;
    }
  }
}

export default new VideoStore();
